<template>
  <div v-if="food_recipe">
    <h2 v-text="`${food_recipe.name} Recipe`" />

    <img
      v-if="food_recipe.image_url"
      :src="food_recipe.image_url"
      :alt="`${food_recipe.name} featured recipe image`"
      class="w-100"
    >

    <table class="table table-bordered">
      <tr v-if="food_recipe.allergens">
        <th>Allergens</th>
        <td v-text="food_recipe.allergens.join(', ')" />
      </tr>
      <tr v-if="food_recipe.food_groups">
        <th>Food Groups</th>
        <td v-text="food_recipe.food_groups.join(', ')" />
      </tr>
      <tr>
        <th>Ingredients</th>
        <td>
          <ul class="mb-0">
            <li
              v-for="ingredient of food_recipe.items"
              :key="ingredient.id"
            >
              {{ normalizeIngredientQuantity(ingredient.ingredient_quantity) }}
              {{ normalizeIngredientUnit(ingredient.ingredient_quantity_unit) }}
              {{ ingredient.item.name }}
            </li>
          </ul>
        </td>
      </tr>
      <tr>
        <th>Directions</th>
        <td
          style="white-space: pre-wrap"
          v-text="food_recipe.directions"
        />
      </tr>
      <tr>
        <th>Servings</th>
        <td v-text="`${normalizeIngredientQuantity(food_recipe.servings)}`" />
      </tr>
      <tr
        v-for="spiral of food_recipe.spirals"
        :key="spiral.spiral_name"
      >
        <th v-text="`${spiral.spiral_name.toUpperCase()} Info`" />
        <td>
          <strong>Factor &ndash;</strong>
          <span v-text="`${spiral.rm_factor}${spiral.rm_color}`" />
          <br>
          <strong>Serving Size &ndash;</strong>
          <span v-text="displayIngredient(spiral.rm_individual_serving_g, food_recipe.servings_unit)" />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import axios from "axios";
import {mapGetters} from "vuex";
import FoodCalculator from '../components/FoodCalculator';
import {FRIENDLY_UNITS} from "../recipe_maker_vars";

export default {
  name: "EmbeddedFoodRecipe",
  props: {
    data: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      food_recipe: undefined,
    };
  },
  mounted() {
    axios.get(this.data).then((response) => {
      if (response && response.status === 200 && response.data) {
        this.food_recipe = response.data.data;

        return;
      }

      throw response;
    });
  },
  computed: {
    ...mapGetters({
      user: 'user/user'
    }),
  },
  methods: {
    normalizeIngredientQuantity(quantity) {
      const num = Number.parseFloat(quantity);

      if (Number.isNaN(num)) {
        return quantity;
      }

      const [whole, numerator, denominator] = this.toMixedFraction(num);

      if (denominator > 1 && denominator <= 8) {
        if (whole) {
          return `${whole} ${numerator}/${denominator}`;
        }

        return `${numerator}/${denominator}`;
      }

      return num;
    },
    toMixedFraction(decimal) {
      const whole = Math.floor(decimal);
      const denominator = Math.pow(10, (decimal - Math.floor(decimal)).toString().length - 2);
      const numerator = (decimal - Math.floor(decimal)) * denominator;
      const divisor = this.greatestCommonDivisor(numerator, denominator);

      return [
        whole,
        Math.floor(numerator / divisor),
        Math.floor(denominator / divisor),
      ];
    },
    greatestCommonDivisor(numerator, denominator) {
      if (denominator < 0.000001)
        return numerator;

      return this.greatestCommonDivisor(denominator, Math.floor(numerator % denominator));
    },
    normalizeIngredientUnit(unit) {
      return FoodCalculator.displayconvert[unit] ?? unit;
    },
    displayIngredient(quantityGrams, conversionUnit) {
      if (quantityGrams === undefined || quantityGrams === null) {
        return '';
      }

      return (Math.round(FoodCalculator.grams_to_units(quantityGrams, conversionUnit) * 10) / 10) + ' ' + FRIENDLY_UNITS[conversionUnit];
    },
  },
}
</script>

<style scoped>

</style>
